'use strict';
const initSqlJs = require('sql.js');
const fs = require('fs');
const path = require('path');

export interface StoredAnswer {
    query: string;
    complete: boolean;
}

export interface PuzzleDef {
    title: string;
    answer: Query;
    table: Query;
    guess: Query;
    complete: boolean;
    id: string;
}

export interface Query {
    query?: string;
    error?: string;
    result?: Result[];
}

export interface Result {
    columns: string[];
    values: any[][];
}


const queries: PuzzleDef[] = [
    {
        answer: {query: `
SELECT
    owner,
    weight,
    max(weight) OVER (order by owner) AS max_weight
FROM catweights 
` },
        table: {query: 'select * from catweights;'},
        guess: {},
        title: 'Find how many cats every owner has',
        id: "cat-number",
        complete: false,
    },
    {
        answer: {query: 'select owner, count(*) from cats group by owner;'},
        table: {query: 'select * from cats;'},
        guess: {},
        title: 'Find how many cats every owner has',
        id: "count-cats",
        complete: false,
    },
    {
        answer: {query: 'select owner from cats group by owner having count(*) > 1;'},
        table: {query: 'select * from cats;'},
        guess: {},
        title: 'Find every owner with more than one cat',
        id: "multiple-cats",
        complete: false,
    },
    {
        answer: {query: "select owner, group_concat(name, ', ') AS cat_names from cats group by owner;"},
        table: {query: 'select * from cats;'},
        guess: {},
        title: 'Get a comma-separated list of all cats owned by each owner',
        id: "comma-separated-cats",
        complete: false,
    },
];


export class Database {
    public currentTime: Date = new Date();
    public SQLite: any = null;
    public db: any = null;

    constructor(SQLite: any) {
        this.SQLite = SQLite;
    }

    getDbContents() {
        return new Promise(function (resolve, reject) {
            let xhr = new XMLHttpRequest();
            xhr.open('GET', '/db.sqlite', true);
            xhr.responseType = 'arraybuffer';
            xhr.onload = e => {
                if (xhr.status >= 200 && xhr.status < 300) {
                    resolve(new Uint8Array(xhr.response));
                } else {
                    reject({
                        status: xhr.status,
                        statusText: xhr.statusText
                    });
                }
            };
            xhr.onerror = function () {
                reject({
                    status: xhr.status,
                    statusText: xhr.statusText
                });
            };
            xhr.send();
        });
    }

    async init() {
        try {
            const contents = fs.readFileSync('./public/db.sqlite');
            this.db = new this.SQLite.Database(contents);
        } catch {
            const contents = await this.getDbContents();
            this.db = new this.SQLite.Database(contents);
        }
    }

    public exec(query: Query) {
        try {
            query.result = this.db.exec(query.query!);
            query.error = undefined
            if (!(query.result!)[0]) {
                query.result = undefined
                query.error = "that's a valid query, but it didn't return any results :("
            }
        } catch(error) {
            console.log(error)
            console.log(query.query)
            query.result = undefined
            query.error = error.message
        }
    }
}
